import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useRef } from 'react';
import { BREAKPOINTS } from '@libs/common-next';
import { useHeaderLayoutStore } from '../../shared';
const MENU_POINTER_MEDIA_QUERY = '(hover: hover) and (pointer: fine)';
export function useHeaderMainSection() {
  const $ = _c(3);
  const containerRef = useRef(null);
  const setIsDesktopMenu = useHeaderLayoutStore(_temp);
  let t0;
  let t1;
  if ($[0] !== setIsDesktopMenu) {
    t0 = () => {
      const container = containerRef.current;
      if (!container) {
        return;
      }
      const mediaQuery = window.matchMedia(MENU_POINTER_MEDIA_QUERY);
      let containerWidth = 0;
      const update = () => setIsDesktopMenu(containerWidth >= BREAKPOINTS.xl && mediaQuery.matches);
      const observer = new ResizeObserver(t2 => {
        const [entry] = t2;
        containerWidth = entry.contentRect.width;
        update();
      });
      observer.observe(container);
      mediaQuery.addEventListener("change", update);
      return () => {
        observer.disconnect();
        mediaQuery.removeEventListener("change", update);
        setIsDesktopMenu(false);
      };
    };
    t1 = [setIsDesktopMenu];
    $[0] = setIsDesktopMenu;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useLayoutEffect(t0, t1);
  return containerRef;
}
function _temp(state) {
  return state.setIsDesktopMenu;
}